import React, { useState, useEffect, useMemo } from "react";
import { Box, Button } from "@mui/material";
import capitalize from "@mui/material/utils/capitalize";
import { useTranslation } from "react-i18next";
import { styled, useTheme } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { capitalize } from '@mui/material';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "@mui/material/TableContainer";
import ArrowCircleUpRoundedIcon from "@mui/icons-material/ArrowCircleUpRounded";
import ArrowCircleDownRoundedIcon from "@mui/icons-material/ArrowCircleDownRounded";
import RemoveCircleOutlineRoundedIcon from "@mui/icons-material/RemoveCircleOutlineRounded";
import {
  GetDateTimeStringToday,
  getUrlVars,
  GetDateTimeString7DaysAgo,
  GetDateTimeString14DaysAgo,
  getComparator,
  stableSort,
} from "../utils/systemInfo";

import SearchInput from "../common/searchInput.js";
import DevicesService from "../api/devices";
import OrganizationService from "../api/organization";
// import HomePagesMenu from '../common/HomePagesMenu';
import Loading from "../common/loading";
import EnhancedTableHead from "../common/EnhancedTableHead";
import MachinesTableRow from "./machinesTableRow";
import { setMachinesData } from "../store/machinesSlice";
import Breadcrumbs from "../common/breadcrumbs";
import exportTableToCSV from "../common/customFunctions/exportTableToCSV.js";
import GroupSelect from "../common/fleetSelect.js";
import usePrevious from "../common/cutomHooks/usePrevious.js";
import StyledTypography from "../common/StyledTypography.js";
import handleNavigate from "../common/customFunctions/handleNavigate.js";

const StyledTablePagination = styled((props) => <TablePagination {...props} />)(
  ({ theme }) => ({
    color: theme.palette.custom.text,
    "& .MuiTablePagination-selectIcon": {
      color: theme.palette.custom.text,
    },
  })
);
const StyledButton = styled((props) => <Button {...props} />)(({ theme }) => ({
  minWidth: "fit-content",
  width: "150px",
  height: "32px",
  margin: "0px",
  color: theme.palette.custom.buttonTextColor,
  backgroundColor: theme.palette.custom.buttonColor,
  borderColor: theme.palette.custom.borderColor,
  borderWidth: "1px",
  borderStyle: "solid",
  "&:hover": {
    backgroundColor: theme.palette.custom.buttonHoverColor,
    color: theme.palette.custom.buttonHoverTextColor,
    boxShadow: "none",
  },
}));
const headCells = [
  {
    id: "DeviceName",
    numeric: false,
    disablePadding: false,
    label: "Name",
    sort: true,
  },
  {
    id: "DeviceSerial",
    numeric: false,
    disablePadding: false,
    label: "Serial",
    sort: true,
  },
  {
    id: "DeviceType",
    numeric: false,
    disablePadding: true,
    label: "MachineType",
    sort: true,
  },
  {
    id: "DeviceOEM",
    numeric: false,
    disablePadding: true,
    label: "oem",
    sort: true,
  },
  {
    id: "NamedLocationOriginal",
    numeric: false,
    disablePadding: false,
    label: "LastLocation",
    sort: true,
  },
  {
    id: "DeviceLastSeen",
    numeric: false,
    disablePadding: false,
    label: "LastSeen",
    sort: true,
  },
  {
    id: "view",
    numeric: false,
    disablePadding: false,
    label: "View",
    sort: false,
  },
];
function Machines() {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const organziation = useSelector(({ organziation }) => organziation);
  const machines = useSelector(({ machines }) => machines);
  const [opsumInputData, setOpsumInputData] = useState(undefined);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("DeviceLastSeen");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(
    Number(localStorage.getItem("rowsPerPage")) ?? 5
  );
  const [searchText, setSearchText] = useState("");
  const [attributeFilter, setAttributeFilter] = useState({});

  const [selected, setSelected] = useState([]);
  const [loadingValue, setLoadingValue] = useState(true);
  const [rerenderItems, setRerenderItems] = useState(0);
  const [selectLabel, setSelectLabel] = useState(null);
  const pageName =
    window.location.href.split("/")[window.location.href.split("/").length - 1];
  const breadcrumbs = [
    { id: 0, name: "Home", href: "./" },
    { id: 1, name: capitalize(pageName), href: pageName },
  ];
  const DeviceTitleDataName = String(getUrlVars()["DeviceTitleDataName"]);
  const prevPageName = usePrevious(pageName);
  useEffect(() => {
    let currentorganization;
    const controller = new AbortController();
    const { signal } = controller;

    const orgObj =
      organziation ?? JSON.parse(localStorage.getItem("defaultOrganization"));
    if (
      orgObj &&
      (orgObj !== currentorganization || pageName !== prevPageName)
    ) {
      setLoadingValue(true);
      currentorganization = orgObj;
      setOpsumInputData(null);
      const apiKey = orgObj?.api_key_list?.[0]?.key;
      let DevicesClass;

      switch (pageName.toLowerCase()) {
        case "devices":
        case "mydevices":
          DevicesClass = { deviceType: [], source: "iot" };
          break;
        case "machines":
        case "mymachines":
          DevicesClass = {
            deviceType: [
              "nerohub",
              "nanohub",
              "cyberhub",
              "stratahub",
              "nerotrax",
              "train",
              "autonomous hub",
            ],
            source: "",
          };
          break;
        default:
          DevicesClass = { deviceType: ["", ""], source: "" };
          break;
      }

      if (pageName?.includes("my")) {
        setOpsumInputData({
          json: [],
          machineTypeFilter: "",
          machineType: DeviceTitleDataName || "machine",
        });
        dispatch(
          setMachinesData({
            json: [],
            machineTypeFilter: "",
            machineType: DeviceTitleDataName || "machine",
          })
        );

        OrganizationService.GetPersonDeviceLink({
          operation_uid: orgObj?.uid,
          device_id: "",
          person_id: localStorage.getItem("assignToUser"),
          apiKey: apiKey,
          signal,
        })
          .then((json) => {
            if (json?.person_device_link?.length) {
              const personDeviceLinkArray = json?.person_device_link.filter(
                (m) =>
                  m.link &&
                  (DevicesClass.deviceType.length === 0 ||
                    DevicesClass.deviceType.some((type) =>
                      m.device_type?.toLowerCase()?.includes(type)
                    )) &&
                  m.source.toLowerCase()?.includes(DevicesClass.source)
              );

              setOpsumInputData({
                json: personDeviceLinkArray,
                machineTypeFilter: "",
                machineType: DeviceTitleDataName || "machine",
              });
              dispatch(
                setMachinesData({
                  json: personDeviceLinkArray,
                  machineTypeFilter: "",
                  machineType: DeviceTitleDataName || "machine",
                })
              );
            }
            setLoadingValue(false);
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted");
            } else if (process.env.NODE_ENV === "development") {
              console.log(error);
            }
          });
      } else {
        setOpsumInputData({
          json: [],
          machineTypeFilter: "",
          machineType: DeviceTitleDataName || "machine",
        });
        dispatch(
          setMachinesData({
            json: [],
            machineTypeFilter: "",
            machineType: DeviceTitleDataName || "machine",
          })
        );

        DevicesService.getDevices({
          deviceID: "",
          DeviceType: DevicesClass.deviceType,
          Source: DevicesClass.source,
          apiKey,
          historyFromDST: "",
          historyToDST: GetDateTimeStringToday(),
          signal,
        })
          .then((json) => {
            if (json && json.device_profile && json.device_profile.length > 0) {
              setOpsumInputData({
                json: json.device_profile,
                machineTypeFilter: "",
                machineType: DeviceTitleDataName || "machine",
              });
              dispatch(
                setMachinesData({
                  json: json.device_profile,
                  machineTypeFilter: "",
                  machineType: DeviceTitleDataName || "machine",
                })
              );
            }
            setLoadingValue(false);
          })
          .catch((error) => {
            if (error?.name === "AbortError") {
              console.log("Fetch aborted");
            } else if (process.env.NODE_ENV === "development") {
              console.log("getUserTypePermissionserrorr", error);
            }
          });
      }
    }

    return () => {
      controller.abort();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageName, rerenderItems]);

  const handleArrowIcon = (newValue, OldValue, reverse, fontSize) => {
    if (newValue > OldValue) {
      return reverse ? (
        <ArrowCircleDownRoundedIcon
          color={theme.palette.custom.text}
          //{reverse ? "#00B000" : "red"}
          sx={{
            minHeight: 48,
            color: "red",
            fontSize: fontSize ? fontSize : 24,
          }}
        />
      ) : (
        <ArrowCircleUpRoundedIcon
          sx={{
            minHeight: 48,
            color: "#00B000",
            fontSize: fontSize ? fontSize : 24,
          }}
        />
      );
    } else if (newValue < OldValue) {
      return reverse ? (
        <ArrowCircleUpRoundedIcon
          color={theme.palette.custom.text}
          //{reverse ? "#00B000" : "red"}
          sx={{
            minHeight: 48,
            color: "#00B000",
            fontSize: fontSize ? fontSize : 24,
          }}
        />
      ) : (
        <ArrowCircleDownRoundedIcon
          sx={{
            minHeight: 48,
            color: "red",
            fontSize: fontSize ? fontSize : 24,
          }}
        />
      );
    } else {
      return (
        <RemoveCircleOutlineRoundedIcon
          sx={{
            minHeight: 48,
            color: "grey",
            fontSize: fontSize ? fontSize : 24,
          }}
        />
      );
    }
  };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    localStorage.setItem("rowsPerPage", event.target.value);
    setPage(0);
  };
  const handleClick = (event, row) => {
    const selectedIndex = selected.indexOf(row.DeviceID);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, row.DeviceID);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  function handleView(event, row) {
    const allDevices = machines;
    const thisDevice = allDevices.find((d) => d.DeviceID === row.DeviceID);
    // console.log(allDevices, row)
    const twinTypes = [
      "nngen2_ble_jumbo_twin_left",
      "nngen2_ble_jumbo_twin_right",
    ];
    const isTwin = twinTypes.includes(thisDevice?.DeviceType);

    switch (row.DeviceTitleDataName) {
      case "Device":
        if (isTwin) {
          const serialLength = thisDevice.DeviceSerial.length;
          const numericPart =
            thisDevice.DeviceSerial.slice(-3).replace(/\D/g, "") ||
            thisDevice.DeviceSerial.slice(-2).replace(/\D/g, "");
          const nonNumberPart = thisDevice.DeviceSerial.slice(
            0,
            serialLength - numericPart.length
          );
          let numValue = parseInt(numericPart, 10);
          if (thisDevice.DeviceType === "nngen2_ble_jumbo_twin_right") {
            numValue -= 1;
          } else if (thisDevice.DeviceType === "nngen2_ble_jumbo_twin_left") {
            numValue += 1;
          }
          const newSerial = `${nonNumberPart}${numValue
            .toString()
            .padStart(numericPart.length, "0")}`;

          const twinType =
            thisDevice.DeviceType === "nngen2_ble_jumbo_twin_left"
              ? "nngen2_ble_jumbo_twin_right"
              : "nngen2_ble_jumbo_twin_left";

          const pair = allDevices.find(
            (d) => d.DeviceType === twinType && d.DeviceSerial === newSerial
          );
          if (pair) {
            handleNavigate(
              event,
              navigate,
              `/deviceCompare?device=${thisDevice.DeviceID}&device2=${pair.DeviceID}&DeviceTitleDataName=${row.DeviceTitleDataName}`
            );
            console.log(newSerial, thisDevice, pair);
            return;
          }
        } else {
          handleNavigate(
            event,
            navigate,
            `/device?device=${row.DeviceID}&DeviceTitleDataName=${row.DeviceTitleDataName}&Dashboard=${row.GrafanaDashboardUID}&MachineName=${row.DeviceName}&device_uid=${row.DeviceID}`
          );
        }
        break;
      case "Machine":
      default:
        handleNavigate(
          event,
          navigate,
          `/device?device=${row.DeviceID}&DeviceTitleDataName=${row.DeviceTitleDataName}`
        );

        break;
    }
  }
  function handleSearch(ev) {
    setPage(0);
    setLoadingValue(true);
    const newSearchText = ev.target.value;
    setSearchText(newSearchText);
    let opsumInputObj = opsumInputData;
    opsumInputObj.machineTypeFilter = "";
    opsumInputObj.newSearchText = newSearchText;
    dispatch(setMachinesData(opsumInputObj));
    setLoadingValue(false);
  }
  const visibleRows = useMemo(
    () => {
      if (machines && machines.length > 0) {
        return stableSort(
          machines.filter(
            (m) =>
              m[attributeFilter.attribute] === attributeFilter.value ||
              !attributeFilter.attribute
          ),
          getComparator(order, orderBy)
        ).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
      } else {
        return [];
      }
    },
    [order, orderBy, page, rowsPerPage, machines, attributeFilter]
    //[page, rowsPerPage, safety],
  );
  const isSelected = (name) => selected.indexOf(name) !== -1;
  // const productivityLabels = [t("Work Time"), t("Idle Time"), t("Offline Time")];
  return (
    <Box
      sx={{
        p: "12px",
        minHeight: "90vh",
        height: "fit-content",
        overflow: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { xs: "block", sm: "center" },
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ display: { xs: "block", sm: "flex" } }}>
          <Box sx={{ width: "100%" }}>
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            <Typography
              sx={{
                fontSize: "45px",
                mb: 0,
                color: theme.palette.custom.text,
              }}
              variant="h2"
              gutterBottom
            >
              {pageName?.toLocaleLowerCase()?.includes("devices")
                ? t("Devices")
                : t("Machines")}
            </Typography>
          </Box>
        </Box>
        <StyledButton
          variant="contained"
          onClick={() => setRerenderItems((r) => r + 1)}
        >
          {t("ClearBrowserCache")}
        </StyledButton>
      </Box>
      <Divider
        sx={{ my: "10px", backgroundColor: theme.palette.custom.borderColor }}
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <SearchInput searchText={searchText} handleSearch={handleSearch} />
        {machines?.length > 0 && (
          <GroupSelect
            label={
              selectLabel && selectLabel !== "" ? selectLabel : t("Select")
            }
            attributes={[
              {
                id: "DeviceType",
                name: `${
                  pageName === "devices" ? t("Device") : t("Machine")
                } Type`,
              },
              // { id: "DeviceOEM", name: "OEM" },
            ]}
            rows={machines}
            onChange={(value, attribute) => {
              setSelectLabel(value);
              setAttributeFilter({ value, attribute });
            }}
          />
        )}
      </Box>
      {/* <TextField
                value={searchText}
                onChange={handleSearch}
                margin="normal"
                fullWidth
                id="search"
                label={t('Search')}
                name="search"
                autoFocus
                sx={{
                    width: { xs: '100%', sm: "20%" },
                    borderColor: theme.palette.custom.borderColor,
                    borderRadius: '11px',
                    backgroundColor: theme.palette.custom.light

                }}
            /> */}
      {loadingValue ? (
        <Box sx={{ height: "30vh", pt: "10%" }}>
          <Loading />
        </Box>
      ) : (
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
            <EnhancedTableHead
              isDevice={pageName === "devices"}
              headCells={headCells.filter(
                (hc) =>
                  hc.id !== "NamedLocationOriginal" ||
                  visibleRows.find(
                    (vr) =>
                      vr.NamedLocationOriginal &&
                      vr.NamedLocationOriginal !== "Unknown"
                  )
              )}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />

            <TableBody>
              {machines && machines.length > 0 && visibleRows.length ? (
                visibleRows.map((row, index) => {
                  const isItemSelected = isSelected(row.DeviceID);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <MachinesTableRow
                      key={index}
                      row={row}
                      isDevice={pageName === "devices"}
                      handleClick={handleClick}
                      handleArrowIcon={handleArrowIcon}
                      dateFromBefore={GetDateTimeString14DaysAgo()}
                      dateFrom={GetDateTimeString7DaysAgo()}
                      dateto={GetDateTimeStringToday()}
                      isItemSelected={isItemSelected}
                      labelId={labelId}
                      handleView={handleView}
                      showNamedLocationOriginal={visibleRows.find(
                        (vr) =>
                          vr.NamedLocationOriginal &&
                          vr.NamedLocationOriginal !== "Unknown"
                      )}
                    />
                  );
                })
              ) : (
                <StyledTypography>{t("No entries found")}</StyledTypography>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <StyledTablePagination
        SelectProps={{
          inputProps: {
            MenuProps: {
              PaperProps: {
                sx: {
                  backgroundColor: theme.palette.secondary.dark,
                  color: theme.palette.custom.text,
                  "& .MuiMenuItem-root.Mui-selected": {
                    backgroundColor: theme.palette.custom.borderColor,
                  },
                  "& .MuiMenuItem-root:hover": {
                    backgroundColor: "blue",
                  },
                  "& .MuiMenuItem-root.Mui-selected:hover": {
                    backgroundColor: "blue",
                  },
                },
              },
            },
          },
        }}
        rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100]}
        component="div"
        count={machines ? machines.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Button
        variant="contained"
        sx={{
          backgroundColor: theme.palette.custom.borderColor,
          color: "white",
          "&:hover": {
            backgroundColor: theme.palette.custom.buttonHoverColor,
            color: theme.palette.custom.buttonHoverTextColor,
            boxShadow: "none",
          },
          float: "right",
          width: "min-content",
          whiteSpace: "nowrap",
          padding: "1rem",
        }}
        onClick={() =>
          exportTableToCSV(
            headCells.filter(
              (hc) =>
                hc.id !== "NamedLocationOriginal" ||
                visibleRows.find(
                  (vr) =>
                    vr.NamedLocationOriginal &&
                    vr.NamedLocationOriginal !== "Unknown"
                )
            ),
            visibleRows,
            "Machines List"
          )
        }
      >
        {t("Download List (*.csv)")}
      </Button>
    </Box>
  );
}

export default Machines;
